// Custom error classes for better error handling

export class AuthTimeoutError extends Error {
  constructor(message: string = 'Authentication timeout occurred') {
    super(message);
    this.name = 'AuthTimeoutError';
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AuthTimeoutError);
    }
  }
}

export class AuthenticationError extends Error {
  constructor(message: string = 'Authentication failed') {
    super(message);
    this.name = 'AuthenticationError';
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AuthenticationError);
    }
  }
}

// Type guard to check if an error is an AuthTimeoutError
export function isAuthTimeoutError(error: unknown): error is AuthTimeoutError {
  return error instanceof AuthTimeoutError;
}

// Type guard to check if an error is an AuthenticationError
export function isAuthenticationError(
  error: unknown,
): error is AuthenticationError {
  return error instanceof AuthenticationError;
}
